<template>

  <b-row>
    <b-col>
      <b-card
        :style="onlyView ? '' : isModalView" 
        no-body
        :class="{ 'open': visibleBody }"
      >
        <b-card-header
          :class="{ 'collapsed': !visibleBody }"
          :aria-expanded="visibleBody ? 'true' : 'false'"
          role="tab"
          data-toggle="collapse"
          @click="onVisibleBody(!visibleBody)"
          style="padding: 0 1px; color: black; font:45px; cursor: pointer;"
        >
          <span class="lead collapse-title"><strong>SEMIOLOGIA CARDIOLOGICA </strong></span>
          <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"/>
        </b-card-header>

        <b-collapse
          v-model="visibleBody"
          role="tabpanel"
        >
          <b-card-body style="padding: 1px">

            <b-tabs card>

              <b-tab title="Escala de Framigham" active>
                <EscalaFramingham/>
              </b-tab>

              <b-tab title="Escala de NYHA">
                <EscalaNyha/>
              </b-tab>
              
            </b-tabs>

          </b-card-body>
        </b-collapse>
      </b-card>
    </b-col>
  </b-row>
</template>


<script>
import EscalaFramingham from './EscalaFramingham.vue';
import EscalaNyha       from './EscalaNyha.vue';

export default{
  name: "SemiologiaCardiologica",

  props: {
    onlyView: {
      type: Boolean,
      default: false
    }
  },

  components: {
    EscalaFramingham,
    EscalaNyha,
  },

  data(){
    return{
      visibleBody: true,
    }
  },


  methods:{

    onVisibleBody(visible){
      this.visibleBody = visible
    }
  },


  computed:{
   

    isModalView() {
      return {
        margin: '0',
        border: '1px solid #2980b9',
        padding: '0 10px'

      }
    },

  },

}
</script>

